const e = "data:image/svg+xml,%3csvg%20viewBox='0%200%2030%2030'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='30'%20height='30'%20rx='4'%20fill='%23575859'/%3e%3c/svg%3e";
export {
  e as default
};
//# sourceMappingURL=icon-unchecked.svg.js.map
